import { render } from "./UserDescription.vue?vue&type=template&id=bdb0dc9c"
import script from "./UserDescription.vue?vue&type=script&lang=js"
export * from "./UserDescription.vue?vue&type=script&lang=js"

import "./UserDescription.vue?vue&type=style&index=0&id=bdb0dc9c&scooped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__